module.exports = __webpack_public_path__ + "static/media/london_ulez_map.64b616fe.png";